module.exports = {"optin_privacy":{"componentName":"OptinPrivacy"}}